<div class="master-modal reviepw_items_modal" role="dialog">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <!-- Modal-Header -->
            <div class="modal-header">
                <h4 class="modal-title"> News Feed Liked Users </h4>
                <div class="modal_close_btn">
                    <span (click)="closeDialog()" class="modal-close"><i class="material-icons">close</i></span>
                </div>
            </div>

            <div mat-dialog-content>
                <!-- Modal-Body -->
                <div class="modal-body">
                    <ng-container *ngIf="likedUsersData.length > 0; else noUsers">
                        <div class="followers_list_box w-100" *ngFor="let user of likedUsersData">
                            <div class="media">
                                <div class="media-left">
                                    <img [src]="user?.profile_image?.url || user?.logo?.url"
                                        onerror="this.src='../../../../../assets/images/avatar.png'">
                                </div>
                                <div class="media-body">
                                    <h4>{{ user?.name }}</h4>
                                    <p>{{ user?.profession_type }}</p>
                                    <p>{{ user?.__typename }}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #noUsers>
                        <p class="no-users-message">No users have liked this post yet.</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>